package com.essntl.features.task.ui.alltasks

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel

interface AllTasksNavigation {
    data object AddTask : AllTasksNavigation
    data class EditTask(val taskId: String) : AllTasksNavigation
    data object ShowOverdueTasks : AllTasksNavigation
    data object CloseSidePanel : AllTasksNavigation
    data class EditClient(
        val client: ClientModel,
        val itinerary: ItineraryModel,
    ) : AllTasksNavigation
}